import {buildRoute} from '../../../http';
import {
  endpoints,
  getProductVariantOptionApi,
  saveProductVariantOptionApi,
  updateProductVariantOptionApi,
  deleteProductVariantOptionApi,
} from '../api';

export function saveProductVariantOptionService(variantOption: {
  [key: string]: any,
}) {
  return saveProductVariantOptionApi(variantOption).toPromise();
}

export function getProductVariantOptionService(
  id: string
): Promise<ProductVariantOption> {
  return getProductVariantOptionApi(undefined, {
    route: buildRoute(endpoints.GET_PRODUCT_VARIANT_OPTION, [id]),
  }).toPromise();
}

export function updateProductVariantOptionService(
  body: {[key: string]: any},
  id: string
): Promise<ProductVariantOption> {
  return updateProductVariantOptionApi(body, {
    route: buildRoute(endpoints.GET_PRODUCT_VARIANT_OPTION, [id]),
  }).toPromise();
}

export function deleteProductVariantOptionService(id: string) {
  return deleteProductVariantOptionApi({
    route: buildRoute(endpoints.DELETE_PRODUCT_VARIANT_OPTION, [id]),
  }).toPromise();
}
